import React, { useState } from 'react';
import { Modal } from 'reactstrap';

const WarningDialog3 = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Modal
      centered
      isOpen={isOpen}
      style={{
        width: '320px',
        margin: 'auto'
      }}
    >
      <div className='modal-image-section'>
        <p
          style={{
            fontWeight: 'bold',
            padding: '1rem',
            textAlign: 'center',
            fontSize: '.8rem',
            lineHeight: '1.2'
          }}
        >
          *After you paid, you must come back here to submit the Ref/UTR No.(12
          digits) . then your money is credited to your account.
        </p>
        <div
          className='modal-image-section'
          style={{ height: '400px', overflow: 'auto' }}
        >
          <img src='/images/utr_example.png' alt='warning' className='img1' />
        </div>

        <div style={{ width: '100%', padding: '.5rem' }}>
          <button
            className={'augest-submit-btn'}
            style={{ borderRadius: '25px', background: 'rgb(42, 181, 255)' }}
            onClick={() => setIsOpen(false)}
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default WarningDialog3;
